import { render, staticRenderFns } from "./searchVoter.vue?vue&type=template&id=2b266770"
import script from "./searchVoter.vue?vue&type=script&lang=js"
export * from "./searchVoter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports